import { Col, ColProps } from "react-bootstrap";

export function AutoCol({ style, ...props }: Readonly<ColProps>) {
    return <Col {...props} sm="auto" style={{ ...style, flex: "0 0 auto" }} />;
}
